// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1-0TJ","right":"Footer_right__HXukd","buttons":"Footer_buttons__3BvNz"};